module.exports = __webpack_public_path__ + "static/media/email-opened.8715c9f0.svg";